<template>
    <div class="w-full grid grid-cols-1 gap-11 | lg:gap-3.5 lg:grid-cols-12 | xl:gap-7">
        <div class="order-last | lg:order-first lg:col-span-4 | xl:pr-12">
            <ul 
                v-if="map.tabs && map.tabs.length"
                ref="dropdownList"
                class="w-full border-t border-green border-solid">
                <li 
                    v-for="(tab, i) in map.tabs" 
                    :key="`map-first-lvl-${i}`"
                    class="border-b border-green border-solid py-[18px] | xl:py-4 | 2xl:py-6">
                        <span 
                            class="cursor-pointer block w-full relative uppercase text-gmap-heading pr-7 | xl:pr-10"
                            @click="toggleList(i)">{{ tab.tab_name }}
                            <span 
                                class="text-gmap-heading--arrow"
                                :class="{'isActive' : activeTabIndex === i && isDropdownActive}"></span>
                                
                            <!-- <span 
                                v-show="isDropdownActive && activeTabIndex === i"
                                class="w-full z-[1] block absolute left-0 top-full bg-white h-5 | md:h-[18px] | xl:h-5 | 2xl:h-8"></span> -->
                        </span>
                        <transition name="slide">
                            <div 
                                v-if="isDropdownActive && activeTabIndex === i"
                                :key="`dropdown-item-${i}-${isDropdownActive}-${activeTabIndex}`"
                                class="pt-5 relative | md:pt-[18px] md:pb-2 | xl:pt-5 xl:pb-4 | 2xl:pt-8 2xl:pb-0">
                                <div 
                                    class="overflow-y-auto relative h-full custom-scrollbar"
                                    :style="`max-height: ${maxLiHeight}px`">
                                    <ul>
                                        <li 
                                            v-for="(tabItem, index) in tab.tab_items" 
                                            :key="`map-second-lvl-${index}`"
                                            @mouseover="openMarker(index)"
                                            @mouseout="openMarker(null)"
                                            class="text-gmap-item flex hover:underline">
                                            <span 
                                                class="w-9">{{ calculateIndex(index) }}</span>
                                            <span
                                                class="flex-1">{{ tabItem.name }}</span></li>
                                    </ul>
                                </div>
                            </div>                            
                        </transition>
                        
                </li>
            </ul>
        </div>
        <div ref="mapHolder" class="lg:col-span-7 lg:col-start-6 | xl:col-span-8">
            <!-- aspect-[423/529] | md:aspect-[768/498] | lg:aspect-[583/627] | xl:aspect-[883/702] |  2xl:aspect-[1230/842]  -->
            <div class="relative w-screen -ml-[1.688rem] | lg:ml-0 lg:w-[calc(100%+1.688rem)] | xl:w-[calc(100%+1.688rem+53px)] | 2xl:w-[calc(100%+1.688rem+98px)]">
                <div class="w-full pb-[125.05%] mb:pb-[64.84%] lg:pb-[107.5%] xl:pb-[79.50%] 2xl:pb-[68.45%]"></div>
                <GMapMap
                    ref="mapRef"
                    class="w-full h-full absolute top-0 left-0 object-cover"
                    :disableDefaultUI="true"
                    :zoom="6"
                    :options="mapOptions"
                    :center="{ lat: 51.093048, lng: 6.84212 }"
                    map-type-id="roadmap">

                    <GMapMarker
                        :options="{
                            position : { lat: map.main_point.lat, lng: map.main_point.lng },
                            icon: `/wp-content/themes/exchangeTheme/assets/images/icons/map-marker--main-point.svg`
                        }"
                        :clickable="false">
                    </GMapMarker>

                    <GMapMarker
                        v-for="(tabMarker, i) in map.tabs[activeTabIndex].tab_items"
                        :key="`customMarker-${i}-${tabMarker.location.place_id}`"
                        :options="calculateMarkerData(tabMarker.location, i)"
                        ref="markers"
                        :clickable="true"
                        @click="openMarker(i)"
                        @closeclick="openMarker(null)" >
                        <GMapInfoWindow
                            :closeclick="true"
                            @closeclick="openMarker(null)"
                            :opened="openedMarkerID === i">
                            <p class="text">{{ tabMarker.name }}</p>
                        </GMapInfoWindow>
                    </GMapMarker>
                </GMapMap>
            </div>
        </div>
        
    </div>
</template>
<script>
import GMapsStyling from '../utils/gmap-style.json'
import { defineComponent, ref, watch } from "vue";
export default defineComponent({
    name: 'gmap',
    setup(props) {
        const map = JSON.parse(props.mapData);
        const activeTabIndex = props.openOnLoad;

        var mapOptions = {
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            styles: GMapsStyling
        }

        let boundsList = [];

        if(map.main_point) {
            boundsList.push({lat: map.main_point.lat, lng: map.main_point.lng})
        }
        
        const markersList = map.tabs[activeTabIndex].tab_items;
        
        markersList.forEach((marker) => {
            boundsList.push({lat: marker.location.lat, lng:marker.location.lng})
        })

        const initBounds = boundsList;

        const mapRef = ref(null);           
        
        var mapFnc;
        
        watch(mapRef, googleMap => {
            if (googleMap) {
                googleMap.$mapPromise.then(map => {
                    mapFnc = map;
                    centerMap(initBounds, mapFnc);
                })
            }
        });

        function centerMap(computedBounds, mapAPI = mapFnc){
            if(mapAPI) {
                let bounds = new google.maps.LatLngBounds();

                computedBounds.forEach((bound) => {
                    bounds.extend(new google.maps.LatLng(bound.lat, bound.lng))
                })

                mapAPI.fitBounds(bounds);
                
                var listener = google.maps.event.addListener(mapAPI, "idle", function() { 
                    if (mapAPI.getZoom() > 16) mapAPI.setZoom(16); 
                    google.maps.event.removeListener(listener); 
                });
            }
            
        }

        return {
            map, mapRef, centerMap, initBounds, GMapsStyling, mapOptions,
        }
    },
    data() {
        return {
            maxLiHeight: 100,
            isDropdownActive: false,
            activeTabIndex: this.openOnLoad,
            openedMarkerID: null,
        }
    },
    props: {
        mapData: {
            type: String,
            required: true
        },
        openOnLoad: {
            type: Number,
            required: false,
            default: 0,
        }
    },
    mounted() {
        this.centerMap(this.bounds);
        this.matchHeight();
        this.isDropdownActive = true;
        window.addEventListener('resize', this.matchHeight);
        window.addEventListener('orientationchange', this.matchHeight);
    },
    methods: {
        openMarker(id) {
            this.openedMarkerID = id;
        },
        toggleList(index){
            if(this.activeTabIndex === index) {
                this.isDropdownActive = (this.isDropdownActive) ? false : true;
            } else {
                this.activeTabIndex = index;
                this.isDropdownActive = true;
            }
        },  
        matchHeight () {
            let spacing = 0;

            if(window.matchMedia('screen and (min-width: 1920px)').matches) {
                spacing = 32;
            } else if (window.matchMedia('screen and (min-width: 1366px)').matches) {
                spacing = 36;
            } else if (window.matchMedia('screen and (min-width: 768px)').matches) {
                spacing = 26;
            } else {
                spacing = 20;
            }

            this.isDropdownActive = false;
            setTimeout(() => {
                let mapHeight = this.$refs.mapHolder.clientHeight;
                let listHeight = this.$refs.dropdownList.clientHeight;
                this.maxLiHeight = mapHeight - listHeight - spacing;
                
            }, 600);
        },
        calculateIndex(index) {
            index = index + 1;
            if ((index < 10)) {
                return `0${index}`;
            } else {
                return `${index}`;
            }

        },
        calculateInfoboxData(tabItemData) {
            const position = { lat: tabItemData.lat, lng: tabItemData.lng }
            return {
                position : position,
            }
        },
        calculateMarkerData(tabItemData, index = null) {
            const position = { lat: tabItemData.lat, lng: tabItemData.lng }

            if(index != null) {
                return {
                    position : position,
                    icon: `${window.location.origin}/wp-content/themes/exchangeTheme/assets/images/icons/map-marker--standard.svg`,
                    optimized: false,
                    zIndex: ( this.openedMarkerID === index ) ? 9999 : index,
                    label: {
                        color: '#FFFFFF',
                        fontSize: '18px',
                        fontWeight: '300',
                        text: this.calculateIndex(index)
                    }
                }
            } else {
                return {
                    position : position,
                    icon: `${window.location.origin}/wp-content/themes/exchangeTheme/assets/images/icons/map-marker--main-point.svg`,
                }
            }
        },
    },
    watch: {
        bounds(val) {
            this.centerMap(val);
        }
    },
    computed: {
        bounds() {
            let boundsList = [];
            const markersList = this.map.tabs[this.activeTabIndex].tab_items;

            if(this.map.main_point) {
                boundsList.push({lat: this.map.main_point.lat, lng: this.map.main_point.lng})
            }
            
            markersList.forEach((marker) => {
                boundsList.push({lat: marker.location.lat, lng:marker.location.lng})
            })

            return boundsList;
        }
    },
})
</script>

<style lang="scss">
    .gm-style .gm-style-iw {
        @apply bg-green-dark;
    }
    
    .gm-style .gm-style-iw-tc::after {
        @apply bg-green-dark;
    }
</style>